"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var react_1 = require("react");
var useClient_1 = require("../../../../../hooks/useClient");
function useRenderCellViews(cells) {
    var client = (0, useClient_1.useClient)().client;
    var renderCellViews = (0, react_1.useCallback)(cells, 
    // (cellValue: any): ITableCellViews[] => {
    //   return [
    //     { key: "image", content: <div className="text-nowrap text-sm capitalize text-default-foreground">{cellValue}</div> },
    //     {
    //       key: "schedule",
    //       content: <div className="text-nowrap text-sm capitalize text-default-foreground">{formatDateTime(new Date(cellValue?.start_date))}</div>,
    //     },
    //     {
    //       key: "schedule",
    //       content: <div className="text-nowrap text-sm capitalize text-default-foreground">{formatDateTime(new Date(cellValue?.end_date))}</div>,
    //     },
    //   ];
    // },
    [client]);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
